import { mergeDeep } from "./utilities";

const FormRange = (element, options = {}) => {
  const defaultOptions = {
    formRangeClass: 'form-range',
    formRangeInitializedClass: 'form-range--initialized',
    inputClass: 'form-range__input',
    labelsClass: 'form-range__labels',
    labelClass: 'form-range__label',
    labelActiveClass: 'active',
  };

  const settings = mergeDeep(defaultOptions, options);

  if (!element) return;
  
  initRange(element);

  function initRange(range) {
    range.innerHTML = `
          <div class="form-range__input-container">
            ${range.querySelector('.' + settings.inputClass).outerHTML}
            <div class="form-range__track"></div>
            <div class="form-range__connect"></div>
            <div class="form-range__thumb"></div>
          </div>
          <div class="form-range__labels"></div>
    `;
    const input = range.querySelector('.' + settings.inputClass);
    const select = document.getElementById(range.dataset.selectId);
    const labelsElement = range.querySelector('.' + settings.labelsClass);

    input.min = Object.keys(settings.labels)[0];
    input.max = Object.keys(settings.labels).length - 1;

    range.style.setProperty('--steps', Number(input.max) + 1);
    range.style.setProperty('--value', input.value);
    
    Object.keys(settings.labels).forEach(key => {
      labelsElement.appendChild(createLabel(key));
      select.appendChild(createOption(key))
    });
    setActiveLabel(input.value);
    const labelElements = Array.from(labelsElement.querySelectorAll('.' + settings.labelClass));

    function createLabel(i) {
      const el = document.createElement('div');
      el.classList.add('form-range__label');
      el.innerHTML = `<span class="form-range__label-text">${settings.labels[i]}</span>`;
      return el;
    }

    function createOption(i) {
      const el = document.createElement('option');
      el.value = i;
      el.textContent = settings.labels[i];
      return el;
    }

    range.addEventListener('click', e => {
      const label = e.target.closest('.' + settings.labelClass);
      if (!label) return;
      input.value = labelElements.indexOf(label);
      updateRange(input.value);
      select.value = input.value;
      input.focus();
    });

    input.addEventListener('input', e => {
      const value = e.target.value;
      const range = e.target.closest('.' + settings.formRangeClass);
      updateRange(value);
      select.value = value;
    });

    select.addEventListener('change', e => {
      const select = e.target;
      const value = select.value;
      const range = document.querySelector(`[data-select-id="${select.id}"]`);
      updateRange(value)
    });
    
    function updateRange(value) {
      setActiveLabel(value);
      range.style.setProperty('--value', value);
    }

    function setActiveLabel(value) {
      const labels = Array.from(labelsElement.querySelectorAll('.' + settings.labelClass));
      const prevLabel = labels.find(label => label.classList.contains(settings.labelActiveClass));
      const nextLabel = labels[value];
      if (prevLabel) {
        prevLabel.classList.remove(settings.labelActiveClass);
      }
      nextLabel.classList.add(settings.labelActiveClass);
    }

    setTimeout(() => {
      range.classList.add(settings.formRangeInitializedClass);
    }, 0);
  }
}

export default FormRange;
